import { useContext, useMemo, useState } from 'react';

import { AtomMap, MarkerLayer, useDefaultMapLocation } from '@atom/map';
import {
  BoundingBoxSubjectType,
  MapAsset,
  MapData,
  MapLocation,
} from '@atom/types/map';

import LocationsAndAssetsContext from '../LocationsAndAssetsContext';

import TaskMapRecenterControl from './TaskMapRecenterControl';

type TaskMapProps = {
  hoverId?: string;
};

const TaskMap = ({ hoverId = '' }: TaskMapProps) => {
  const defaultLocation = useDefaultMapLocation();
  const { workOrderDetail, task, assets, locations } = useContext(
    LocationsAndAssetsContext,
  );

  const [recenterKey, setRecenterKey] = useState(0);

  const data: MapData = useMemo(
    () => ({
      assets: (assets ?? []) as MapAsset[],
      locations: (locations ?? []).map(
        (item): MapLocation => ({
          id: item.id,
          name: item.name,
          geometry: item.geometry,
          statusId: workOrderDetail?.statusId,
          isActive: hoverId === item?.id,
        }),
      ),
    }),
    [assets, locations, workOrderDetail, hoverId],
  );

  return (
    <AtomMap
      initialViewState={defaultLocation}
      compactToolbars
      customToolbars={
        <TaskMapRecenterControl
          onClick={() => setRecenterKey(key => key + 1)}
        />
      }
      frameTask={{
        subjectType: BoundingBoxSubjectType.ALL,
        taskId: task?.id,
        workOrderId: workOrderDetail?.id,
        frameKey: `${assets?.length ?? 0}:${locations?.length ?? 0}:${recenterKey}`,
      }}
    >
      <MarkerLayer data={data} activeId={hoverId} />
    </AtomMap>
  );
};

export default TaskMap;
